// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2VSgouh0-_q35H83DwVOru","spaceLeft":"IDst3vDCGoJjIP_alhe-F","spaceBoth":"_1ZrP81B7vZFNzuLUwHTm0D","spaceRight":"_2q494a4IXocK1cjv5zq5R-","LockedAccountSection":"_19FS2N9lLdZWAe0uNk9pit","Logo":"N5FH7WRC_g5LPAy03sc_-","Separator":"phianAKhdXQ2IxdgG_W7t","Heading":"OBMcw9qojkNLHkx3resxs","Message":"Gqzd6RNGcOlNEERL8E3ry"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Locked.scss
// module id = 1323
// module chunks = 0